export interface DepartmentPermissionActionTypes {
    type: DepartmentPermissionActions;
    payload?: any;
  }
  
  export enum DepartmentPermissionActions {
    GET_DEPARTMENT_PERMISSION_LIST = "GET_DEPARTMENT_PERMISSION_LIST",
    SET_DEPARTMENT_PERMISSION_LIST = "SET_DEPARTMENT_PERMISSION_LIST",
    SET_DEPARTMENT_PERMISSION_PAGE_COUNT = "SET_DEPARTMENT_PERMISSION_PAGE_COUNT",
    ADD_DEPARTMENT_PERMISSION = "ADD_DEPARTMENT_PERMISSION"
  }
  